import React from 'react';
import { isPlanner, isEngineering, canAccessEngineeringModule, canAccessPlanningModule } from '../../utils/roleConstants';
import { Form, FormGroup, FormControl, Button, Modal, Container, Row, Col } from 'react-bootstrap';
import config from '../../../config';
import DataTable from 'react-data-table-component';
import moment from 'moment';
import { Navigate } from 'react-router';
import utils from '../../utils';
import MasterPartNoInput from '../../_components/MasterPartNoInput';
import DataTableEllipsisText from '../../_components/DataTableEllipsisText';
import TableRowActionMenu from '../../_components/TableRowActionMenu';
import { isPartNoCreateEnabled, MASTER_PART_NO_VALIDATION_STATUS } from '../../utils/masterPartNoValidation';

class BomList extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            id: 0,
            customer: '',
            partNo: '',
            partDesc: '',
            material: '',
            materialDesc: '',
            color: '',
            code: '',
            usage: 0,
            uom: '',
            per: 0,
            where_use: '',
            source: '',
            category: '',
            supplier: '',
            uoms: [],
            sources: [],
            categories: [],
            currentPage: 1,
            rowsPerPage: 10,
            totalRows: 0,
            offset: 0,
            expandedRows: {},
            rawData: [],
            parent_bom_id: null,
            // --- Copy / Paste sub-materials ---
            clipboard: [],           // raw material objects selected for pasting
            copyModalShow: false,    // show/hide copy-selection modal
            copySourceRow: null,     // the parent row whose children are being copied
            copySourceChildren: [],  // direct children of copySourceRow (from rawData)
            selectedCopyIds: new Set(), // IDs currently checked in the copy modal
            isPasting: false,        // loading indicator while paste is in progress
            openDropdownId: null,    // which row's action dropdown is open
            partNoValidationStatus: MASTER_PART_NO_VALIDATION_STATUS.IDLE,
        }
        this.tableRequestSeq = 0;
    }

    // Check if the current mode is 'view' (read-only, no Edit/Delete/New buttons)
    // Rules:
    // - Planner users are ALWAYS in view mode (even if URL says ?mode=edit)
    // - Engineering users are in edit mode by default
    // - URL ?mode=view forces view mode for any user
    isViewMode() {
        const user = JSON.parse(localStorage.getItem('user'));
        // Planners always get view mode - they cannot edit/delete
        if (isPlanner(user) && !isEngineering(user)) return true;

        // For Engineering/superadmin, check URL mode
        const hash = window.location.hash;
        const queryIndex = hash.indexOf('?');
        if (queryIndex === -1) return false;
        const params = new URLSearchParams(hash.substring(queryIndex));
        return params.get('mode') === 'view';
    }

    buildColumns() {
        const viewMode = this.isViewMode();
        this.columns = [
            {
                name: 'No',
                selector: row => row._rowNo,
                cell: row => (
                    <div style={{ display: 'flex', alignItems: 'center', paddingLeft: (row._depth || 0) * 12 }}>
                        {row._hasChildren ? (
                            <span
                                onClick={() => this.toggleRowExpanded(row.id)}
                                style={{ cursor: 'pointer', marginRight: 6, fontSize: 12, userSelect: 'none', width: 16, textAlign: 'center', display: 'inline-block' }}
                            >
                                {this.state.expandedRows[row.id] ? '▼' : '▶'}
                            </span>
                        ) : (
                            <span style={{ display: 'inline-block', width: 22 }}></span>
                        )}
                        <span>{row._rowNo}</span>
                    </div>
                ),
                width: '130px',
            },
            {
                name: 'Part No',
                selector: row => row.material,
                cell: row => <DataTableEllipsisText value={row.material} />,
                sortable: true,
                minWidth: '150px',
                grow: 2,
            },
            {
                name: 'Description',
                selector: row => row.materialDesc,
                cell: row => <DataTableEllipsisText value={row.materialDesc} />,
                sortable: true,
                minWidth: '150px',
                grow: 1,
            },
            {
                name: 'Color',
                selector: row => row.color,
                cell: row => <DataTableEllipsisText value={row.color} />,
                sortable: true,
                width: '100px',
            },

            {
                name: 'UoM',
                selector: row => row.uom,
                cell: row => <DataTableEllipsisText value={row.uom} />,
                sortable: true,
                width: '80px',
            },
            {
                name: 'Usage',
                selector: row => row.usage,
                sortable: true,
                width: '80px',
            },
            {
                name: 'Per',
                selector: row => row.per,
                sortable: true,
                width: '80px',
            },
            {
                name: 'Where Use',
                selector: row => row.where_use,
                cell: row => <DataTableEllipsisText value={row.where_use} />,
                sortable: true,
                width: '100px',
            },
            {
                name: 'Source',
                selector: row => row.source,
                cell: row => <DataTableEllipsisText value={row.source} />,
                sortable: true,
                width: '100px',
            },
            {
                name: 'Category',
                selector: row => row.category,
                cell: row => <DataTableEllipsisText value={row.category} />,
                sortable: true,
                width: '120px',
            },
            {
                name: 'Supplier',
                selector: row => row.supplier,
                cell: row => <DataTableEllipsisText value={row.supplier} />,
                sortable: true,
                width: '100px',
            },
            {
                name: '',
                cell: (row, rowIndex) => {
                    if (viewMode) return null;
                    const hasPaste = this.state.clipboard.length > 0;
                    return (
                        <TableRowActionMenu
                            isOpen={this.state.openDropdownId === row.id}
                            onOpenChange={(isOpen) => this.setState({ openDropdownId: isOpen ? row.id : null })}
                            openTriggerStyle={{
                                backgroundColor: '#e9ecef',
                                boxShadow: 'inset 0 1px 3px rgba(0,0,0,0.1)',
                            }}
                        >
                                    {/* Edit */}
                                    <button className="bom-menu-item" onClick={() => { this.onClickProductSelected(row.id, row, rowIndex); this.setState({ openDropdownId: null }); }}>
                                        Edit
                                    </button>

                                    {/* Add Sub-material */}
                                    <button className="bom-menu-item" onClick={() => {
                                        this.setState({
                                            modalShow: true, newMode: true, parent_bom_id: row.id,
                                            parentMaterial: row.material || '(unnamed)',
                                            material: '', materialDesc: '', color: '', code: '',
                                            usage: 0, uom: '', per: 0, where_use: '', source: '', category: '', supplier: '',
                                            partNoValidationStatus: MASTER_PART_NO_VALIDATION_STATUS.IDLE,
                                            openDropdownId: null,
                                        });
                                    }}>
                                        Add Sub-material
                                    </button>

                                    {/* Copy RM — only for rows with children */}
                                    {row._hasChildren && (
                                        <button className="bom-menu-item bom-menu-item--copy" onClick={() => { this.openCopyModal(row); this.setState({ openDropdownId: null }); }}>
                                            Copy Sub-materials
                                        </button>
                                    )}

                                    {/* Paste RM — only when clipboard is loaded */}
                                    {hasPaste && (
                                        <button
                                            className="bom-menu-item bom-menu-item--paste"
                                            disabled={this.state.isPasting}
                                            style={{ opacity: this.state.isPasting ? 0.5 : 1 }}
                                            onClick={() => { this.pasteSubMaterials(row.id, row.material || '(unnamed)'); this.setState({ openDropdownId: null }); }}
                                        >
                                            {this.state.isPasting ? 'Pasting…' : 'Paste Sub-materials'}
                                        </button>
                                    )}

                                    {/* Divider before destructive action */}
                                    <div style={{ height: '1px', backgroundColor: '#f0f0f0', margin: '4px 0' }} />

                                    {/* Delete */}
                                    <button
                                        className="bom-menu-item bom-menu-item--danger"
                                        onClick={() => {
                                            this.setState({ openDropdownId: null });
                                            window.confirm("Are you sure you want to delete this data?" + (row._hasChildren ? " This will also delete all sub-materials." : "")) &&
                                            this.onDeleteBomItem(row.id);
                                        }}
                                    >
                                        Delete
                                    </button>
                        </TableRowActionMenu>
                    );
                },
                ignoreRowClick: true,
                allowOverflow: true,
                width: viewMode ? '0px' : '60px',
            },
        ];

    }

    componentWillMount() {
        // Extract planningId from URL hash (React Router v6 with HashRouter)
        // URL format: #/bomlist/:planningId
        const hash = window.location.hash;
        let planningId = null;
        const bomListMatch = hash.match(/\/bomlist\/([^\/\?]+)/);
        if (bomListMatch) {
            planningId = bomListMatch[1];
        }
        this.setState({
            processes: [],
            planningId
        });
        const requestOptions = {
            method: 'GET',
            headers: { 'Content-Type': 'application/json' },
        };

        if (localStorage.getItem('user') != null) {

            fetch(`${config.apiUrl}/getMasterData?master_data_id=${planningId}`, {
                method: 'GET',
                headers: { 'Content-Type': 'application/json' },
            })
                .then((response) => {
                    return response.text().then(text => {
                        const data = text && JSON.parse(text);

                        return data;
                    });
                })
                .then(data => {
                    // login successful if there's a user in the response
                    if (data) {
                        this.setState({ customer: data[0].customer, partNo: data[0].partNo, partDesc: data[0].partDesc });
                    }
                });

            const fetchJson = (url) =>
                fetch(url, requestOptions)
                    .then(r => r.text())
                    .then(text => (text ? JSON.parse(text) : []));

            Promise.all([
                fetchJson(`${config.apiUrl}/getAllMaterialUom`),
                fetchJson(`${config.apiUrl}/getAllMaterialSource`),
                fetchJson(`${config.apiUrl}/getAllMaterialCategory`),
            ]).then(([uoms, sources, categories]) => {
                this.setState({ uoms, sources, categories });
                this.buildHtmlTable();
            });

        }
    }

    exportExcel() {
        utils.tableToExcel('bomlist-export-table', 'bomlist', 'Bomlist_' + moment().format('YYYYMMDD') + '.xls');
    };


    /**
     * Recursively flatten nested BOM data into a flat array with depth/numbering metadata.
     * Only includes children of expanded rows.
     */
    flattenBomData(items, depth = 0, parentNo = '', offset = 0) {
        let result = [];
        items.forEach((item, index) => {
            const rowNo = parentNo ? `${parentNo}.${index + 1}` : `${index + offset + 1}`;
            const hasChildren = item.children && item.children.length > 0;
            result.push({
                id: item.id,
                material: item.material,
                materialDesc: item.materialDesc,
                color: item.color,
                code: item.code,
                usage: item.usage,
                uom: utils.mapTo(this.state.uoms, item.uom),
                per: item.per,
                where_use: item.where_use,
                source: utils.mapTo(this.state.sources, item.source),
                category: utils.mapTo(this.state.categories, item.category),
                supplier: item.supplier,
                parent_bom_id: item.parent_bom_id,
                _depth: depth,
                _hasChildren: hasChildren,
                _rowNo: rowNo,
            });
            if (hasChildren && this.state.expandedRows[item.id]) {
                result = result.concat(this.flattenBomData(item.children, depth + 1, rowNo));
            }
        });
        return result;
    }

    /**
     * Toggle expand/collapse for a row and re-flatten data.
     */
    toggleRowExpanded = (id) => {
        this.setState(prev => ({
            expandedRows: { ...prev.expandedRows, [id]: !prev.expandedRows[id] }
        }), () => {
            const offset = (this.state.currentPage - 1) * this.state.rowsPerPage;
            const products = this.flattenBomData(this.state.rawData, 0, '', offset);
            this.setState({ products });
        });
    }

    buildHtmlTable(page = null, limit = null) {
        const requestOptions = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
        };

        // Use provided page/limit or state values
        const currentPage = page !== null ? page : this.state.currentPage;
        const rowsPerPage = limit !== null ? limit : this.state.rowsPerPage;
        const offset = (currentPage - 1) * rowsPerPage;
        const requestSeq = ++this.tableRequestSeq;

        if (localStorage.getItem('user') != null)
            return fetch(`${config.apiUrl}/getBomList?master_data_id=${this.state.planningId}&limit=${rowsPerPage}&offset=${offset}`, requestOptions)
                .then((response) => {
                    return response.text().then(text => {
                        const data = text && JSON.parse(text);
                        return data;
                    });
                })
                .then(body => {
                    if (requestSeq !== this.tableRequestSeq) return;

                    // Handle both old format (array) and new format (object with data and meta)
                    const dataArray = body.data ? body.data : (Array.isArray(body) ? body : []);

                    if (Array.isArray(dataArray)) {
                        // Store raw nested data, then flatten for display
                        const products = this.flattenBomData(dataArray, 0, '', offset);

                        this.setState({
                            products: products,
                            rawData: dataArray,
                            body: dataArray,
                            totalRows: body.meta && body.meta.total_count ? body.meta.total_count : dataArray.length,
                            currentPage: currentPage,
                            rowsPerPage: rowsPerPage,
                            offset: offset
                        });
                    } else {
                        this.setState({
                            products: [],
                            rawData: [],
                            body: [],
                            totalRows: 0
                        });
                    }
                })
                .catch(error => {
                    if (requestSeq !== this.tableRequestSeq) return;

                    console.error('Error fetching BOM list:', error);
                    this.setState({
                        products: [],
                        rawData: [],
                        body: [],
                        totalRows: 0
                    });
                });
    }

    handlePageChange = (page) => {
        this.setState({ currentPage: page }, () => {
            this.buildHtmlTable(page, this.state.rowsPerPage);
        });
    };

    handleRowsPerPageChange = (newRowsPerPage, page) => {
        this.setState({ rowsPerPage: newRowsPerPage, currentPage: page }, () => {
            this.buildHtmlTable(page, newRowsPerPage);
        });
    };

    handlePartNoValidationChange = (partNoValidationStatus) => {
        this.setState({ partNoValidationStatus });
    };

    handlePartDataMatch = (part) => {
        this.setState({
            materialDesc: part && part.description ? part.description : '',
        });
    };

    onClickProductSelected(cell, row, rowIndex) {
        // Find the record in body by matching id
        const record = this.getNodeById(row.id, this.state.rawData || []) || this.state.body.find(r => r.id === row.id) || (row.id ? row : null);
        if (!record) {
            return;
        }
        this.setState({
            modalShow: true,
            newMode: false,
            id: record.id,
            material: record.material || '',
            materialDesc: record.materialDesc || '',
            color: record.color || '',
            code: record.code || '',
            usage: record.usage || 0,
            uom: record.uom || '',
            per: record.per || 0,
            where_use: record.where_use || '',
            source: record.source || '',
            category: record.category || '',
            supplier: record.supplier || '',
        });
    }

    onDeleteProduct(cell, row, rowIndex) {
        // Find the record in body by matching id, or use row.id directly
        const recordId = row && row.id ? row.id : (this.state.body && this.state.body[rowIndex] ? this.state.body[rowIndex].id : null);
        if (!recordId) {
            return;
        }
        fetch(`${config.apiUrl}/deleteMasterData`, {
            method: "post",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },

            //make sure to serialize your JSON body
            body: JSON.stringify({
                id: recordId,
            })
        })
            .then((response) => {
                if (response.status == 200) {
                    window.alert('Deleted Successfully.');
                    this.buildHtmlTable();
                }
            });
    }

    /**
     * Delete a BOM item and all its descendants via /deleteBomList (cascading delete).
     */
    onDeleteBomItem(id) {
        if (!id) return;
        fetch(`${config.apiUrl}/deleteBomList`, {
            method: "post",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({ id, ...this.getRevisionEditorPayload() })
        })
            .then((response) => {
                if (response.status == 200) {
                    window.alert('Deleted Successfully.');
                    // Clean up expanded state for deleted id
                    this.setState(prev => {
                        const expandedRows = { ...prev.expandedRows };
                        delete expandedRows[id];
                        return { expandedRows };
                    });
                    this.buildHtmlTable();
                }
            })
            .catch(error => {
                console.error('Error deleting BOM item:', error);
                window.alert('Error deleting item.');
            });
    }

    cellButton(cell, row, enumObject, rowIndex) {
        return (
            <div>
                <button
                    style={{ marginRight: 10 }}
                    type="button"
                    onClick={() =>
                        this.onClickProductSelected(cell, row, rowIndex)}
                >
                    Edit
                </button>
                <button
                    style={{ marginRight: 10 }}
                    type="button"
                    onClick={() =>
                        window.confirm("Are you sure you delete this data?") && this.onDeleteProduct(cell, row, rowIndex)}
                >
                    Delete
                </button>
            </div>
        )
    }

    // ---------------------------------------------------------------------------
    // Copy / Paste sub-materials helpers
    // ---------------------------------------------------------------------------

    /**
     * Recursively search rawData tree for a node with the given id.
     */
    getNodeById(id, items) {
        for (const item of items) {
            if (item.id === id) return item;
            if (item.children && item.children.length > 0) {
                const found = this.getNodeById(id, item.children);
                if (found) return found;
            }
        }
        return null;
    }

    getRevisionEditorPayload() {
        const currentUser = JSON.parse(localStorage.getItem('user') || '{}');
        const updatedByName = currentUser.firstName || currentUser.lastName
            ? `${currentUser.firstName || ''} ${currentUser.lastName || ''}`.trim()
            : currentUser.username;

        return {
            updatedBy: currentUser.id || currentUser.accountId || currentUser.username,
            updatedByName,
        };
    }

    /**
     * Open the copy-selection modal with the direct children of the given row
     * pre-selected.
     */
    openCopyModal = (row) => {
        const node = this.getNodeById(row.id, this.state.rawData);
        const children = (node && node.children) || [];
        const preSelected = new Set(children.map(c => c.id));
        this.setState({
            copyModalShow: true,
            copySourceRow: row,
            copySourceChildren: children,
            selectedCopyIds: preSelected,
        });
    }

    /**
     * Confirm the selection and store chosen items in clipboard.
     */
    handleCopyConfirm = () => {
        const { copySourceChildren, selectedCopyIds } = this.state;
        const selected = copySourceChildren.filter(c => selectedCopyIds.has(c.id));
        if (selected.length === 0) {
            window.alert('Please select at least one sub-material to copy.');
            return;
        }
        this.setState({ clipboard: selected, copyModalShow: false });
        window.alert(`${selected.length} sub-material(s) copied to clipboard. Click "Paste RM" on any row to paste them.`);
    }

    /**
     * Recursively POST each item (and its children) to /uploadBomList under
     * the given parentId, preserving the nested structure.
     */
    pasteItemsRecursive = async (items, parentId) => {
        for (const item of items) {
            const body = {
                material: item.material,
                materialDesc: item.materialDesc,
                color: item.color,
                code: item.code,
                usage: item.usage,
                uom: item.uom,
                per: item.per,
                where_use: item.where_use,
                source: item.source,
                category: item.category,
                supplier: item.supplier,
                master_data_id: this.state.planningId,
                parent_bom_id: parentId,
                ...this.getRevisionEditorPayload(),
            };
            const response = await fetch(`${config.apiUrl}/uploadBomList`, {
                method: 'post',
                headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' },
                body: JSON.stringify(body),
            });
            if (response.status === 200) {
                // Try to read the newly created row's id so we can paste its children
                let newId = null;
                try {
                    const data = await response.json();
                    newId = data && (data.id || data.insertId || data.newId);
                } catch (e) { /* API may not return a JSON body */ }
                if (newId && item.children && item.children.length > 0) {
                    await this.pasteItemsRecursive(item.children, newId);
                }
            }
        }
    }

    /**
     * Paste all clipboard items as sub-materials of the target row,
     * auto-expanding it afterwards.
     */
    pasteSubMaterials = async (targetParentId, targetMaterial) => {
        const count = this.state.clipboard.length;
        if (!window.confirm(`Paste ${count} sub-material(s) under "${targetMaterial}"?`)) return;
        this.setState({ isPasting: true });
        try {
            await this.pasteItemsRecursive(this.state.clipboard, targetParentId);
            this.setState(prev => ({
                expandedRows: { ...prev.expandedRows, [targetParentId]: true },
                isPasting: false,
            }));
            window.alert('Sub-materials pasted successfully.');
            this.buildHtmlTable();
        } catch (e) {
            console.error('Error pasting sub-materials:', e);
            this.setState({ isPasting: false });
            window.alert('Error pasting sub-materials. Please try again.');
        }
    }


    render() {
        const user = JSON.parse(localStorage.getItem('user'));
        if (!canAccessPlanningModule(user) && !canAccessEngineeringModule(user)) {
            return <Navigate to="/" />
        }
        // Rebuild columns on every render so Edit/Delete buttons reflect the current URL mode
        this.buildColumns();
        let { keyword, modalShow, newMode, products, customer, partNo, partDesc, material, materialDesc, color, code, usage, uom,
            per, where_use, source, category, supplier } = this.state;
        let handleClose = () => this.setState({ modalShow: false, partNoValidationStatus: MASTER_PART_NO_VALIDATION_STATUS.IDLE });
        let handleSave = () => {
            window.confirm("Are you sure you update this data?") && fetch(`${config.apiUrl}/updateBomList?id=${this.state.id}`, {
                method: "post",
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },

                //make sure to serialize your JSON body
                body: JSON.stringify({
                    material, materialDesc, color, code, usage, uom,
                    per, where_use, source, category, supplier,
                    ...this.getRevisionEditorPayload(),
                })
            })
                .then((response) => {
                    if (response.status == 200) {
                        window.alert('Update Successfully.');

                        this.setState({ modalShow: false });
                        this.buildHtmlTable();
                    }
                });
        }

        let handleCreate = () => {
            const createBody = {
                material, materialDesc, color, code, usage, uom,
                per, where_use, source, category, supplier,
                master_data_id: this.state.planningId,
                ...this.getRevisionEditorPayload(),
            };
            // Include parent_bom_id if creating a sub-material
            if (this.state.parent_bom_id) {
                createBody.parent_bom_id = this.state.parent_bom_id;
            }
            fetch(`${config.apiUrl}/uploadBomList`, {
                method: "post",
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(createBody)
            })
                .then((response) => {
                    if (response.status == 200) {
                        // Auto-expand parent so the new child is visible
                        if (this.state.parent_bom_id) {
                            this.setState(prev => ({
                                expandedRows: { ...prev.expandedRows, [prev.parent_bom_id]: true }
                            }));
                        }
                        this.setState({ modalShow: false, newMode: false, parent_bom_id: null, parentMaterial: null });
                        window.alert('New data created successfully.');
                        this.buildHtmlTable();
                    }
                });
        }

        return (
            <div className="container">
                <div style={{ marginBbottom: '20em', position: 'relative', minHeight: '50px' }}>
                    <FormGroup className="row" as={Row} controlId="formInlinePlanOutput" style={{ marginBottom: '15px' }}>
                        <Col sm={2}><Form.Label>Customer</Form.Label></Col>
                        <Col sm={5}><FormControl readOnly value={customer} style={{ border: '2px solid #666', borderRadius: '4px', padding: '8px 12px', width: '100%', backgroundColor: '#f8f9fa', boxSizing: 'border-box', color: '#212529' }} /></Col>
                        <Col sm={1}><Form.Label>Part No</Form.Label></Col>
                        <Col sm={4}><FormControl readOnly value={partNo} style={{ border: '2px solid #666', borderRadius: '4px', padding: '8px 12px', width: '100%', backgroundColor: '#f8f9fa', boxSizing: 'border-box', color: '#212529' }} /></Col>
                    </FormGroup>
                    <FormGroup className="row" as={Row} controlId="formInlinePlanOutput" style={{ marginBottom: '15px' }}>
                        <Col sm={2}><Form.Label>Part Description</Form.Label></Col>
                        <Col sm={7}><FormControl readOnly value={partDesc} style={{ border: '2px solid #666', borderRadius: '4px', padding: '8px 12px', width: '100%', backgroundColor: '#f8f9fa', boxSizing: 'border-box', color: '#212529' }} /></Col>
                        <Col sm={3} style={{ display: 'flex', gap: '10px', justifyContent: 'flex-end' }}>
                            <Button
                                bsStyle="primary"
                                onClick={e => this.exportExcel()}>Export</Button>
                            {!this.isViewMode() && (
                                <Button
                                    bsStyle="danger"
                                    onClick={e => { this.setState({ modalShow: true, newMode: true, parent_bom_id: null, parentMaterial: null, material: '', materialDesc: '', color: '', code: '', usage: 0, uom: '', per: 0, where_use: '', source: '', category: '', supplier: '', partNoValidationStatus: MASTER_PART_NO_VALIDATION_STATUS.IDLE }); }}>New</Button>
                            )}
                        </Col>
                    </FormGroup>
                    <a id='dlink' style={{ display: 'none' }}></a>
                </div>
                {/* Clipboard toolbar – shown whenever there are items ready to paste */}
                {this.state.clipboard.length > 0 && (
                    <div style={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: '12px',
                        padding: '10px 16px',
                        marginBottom: '10px',
                        backgroundColor: '#e8f4fd',
                        border: '1px solid #90cdf4',
                        borderRadius: '6px',
                        fontSize: '14px',
                    }}>
                        <span style={{ fontSize: '20px' }}>📋</span>
                        <span>
                            <strong>{this.state.clipboard.length}</strong> sub-material(s) ready to paste.
                            Click{' '}<strong style={{ color: '#198754' }}>Paste RM</strong>{' '}
                            on any row to paste them as sub-materials.
                        </span>
                        <button
                            type="button"
                            onClick={() => this.setState({ clipboard: [], isPasting: false })}
                            style={{ marginLeft: 'auto', padding: '4px 12px', fontSize: '12px', cursor: 'pointer', backgroundColor: 'transparent', border: '1px solid #90cdf4', borderRadius: '4px', color: '#555' }}
                        >
                            Clear Clipboard
                        </button>
                    </div>
                )}
                <div id="datatable" className="container" style={{ overflow: 'visible' }} >
                    <DataTable
                        columns={this.columns}
                        data={products || []}
                        pagination
                        paginationServer
                        paginationTotalRows={this.state.totalRows}
                        paginationPerPage={this.state.rowsPerPage}
                        paginationDefaultPage={this.state.currentPage}
                        onChangePage={this.handlePageChange}
                        onChangeRowsPerPage={this.handleRowsPerPageChange}
                        highlightOnHover
                        conditionalRowStyles={[
                            {
                                when: row => row.id === this.state.openDropdownId,
                                style: {
                                    zIndex: 100,
                                    position: 'relative',
                                },
                            },
                            {
                                when: row => (row._depth || 0) > 0,
                                style: row => ({
                                    borderLeft: `3px solid ${['#0d6efd', '#6c757d', '#198754', '#dc3545'][(row._depth - 1) % 4]}`,
                                    backgroundColor: row._depth === 1 ? '#f8f9ff' : row._depth === 2 ? '#f0f4f8' : '#eef2f5',
                                    marginLeft: (row._depth || 0) * 5, // Add a tiny bit of horizontal shift to whole row
                                }),
                            },
                        ]}
                    />
                </div>

                {/* Hidden export table for Excel */}
                <div id="bomlist-export-table" style={{ display: 'none' }}>
                    <table border="1" style={{ width: '100%', borderCollapse: 'collapse' }}>
                        <thead>
                            <tr>
                                <th>No</th>
                                <th>Part No</th>
                                <th>Description</th>
                                <th>Color</th>
                                <th>UoM</th>
                                <th>Per</th>
                                <th>Where Use</th>
                                <th>Source</th>
                                <th>Category</th>
                                <th>Supplier</th>
                            </tr>
                        </thead>
                        <tbody>
                            {(products || []).map((item, index) => (
                                <tr key={item.id || index}>
                                    <td>{item._rowNo || index + 1}</td>
                                    <td>{item.material || ''}</td>
                                    <td>{item.materialDesc || ''}</td>
                                    <td>{item.color || ''}</td>
                                    <td>{item.uom || ''}</td>
                                    <td>{item.per || 0}</td>
                                    <td>{item.where_use || ''}</td>
                                    <td>{item.source || ''}</td>
                                    <td>{item.category || ''}</td>
                                    <td>{item.supplier || ''}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
                <Modal size="lg" show={modalShow} onHide={handleClose}
                    aria-labelledby="example-modal-sizes-title-lg" dialogClassName="modal-90w">
                    <Modal.Header closeButton>
                        {newMode ? (
                            <Modal.Title>{this.state.parent_bom_id ? `New Sub-Material of "${this.state.parentMaterial}"` : 'New'}</Modal.Title>
                        ) : (
                            <Modal.Title>Edit</Modal.Title>
                        )}
                    </Modal.Header>
                    <Modal.Body>
                        <div>
                            <Form>
                                <FormGroup className="row" as={Row} controlId="formInlineCustomer" style={{ marginBottom: '20px' }}>
                                    <Col sm={3} style={{ paddingRight: '10px', paddingLeft: '10px' }}><Form.Label>Part No</Form.Label></Col>
                                    <Col sm={3} style={{ paddingRight: '10px', paddingLeft: '10px' }}>
                                        <MasterPartNoInput
                                            value={material}
                                            onChange={value => this.setState({ material: value })}
                                            enabled={true}
                                            onValidationChange={this.handlePartNoValidationChange}
                                            onPartDataMatch={this.handlePartDataMatch}
                                            formControlProps={{
                                                style: { border: '2px solid #666', borderRadius: '4px', padding: '8px 12px', width: '100%', backgroundColor: '#f8f9fa', boxSizing: 'border-box', color: '#212529' }
                                            }}
                                        />
                                    </Col>
                                    <Col sm={3} style={{ paddingRight: '10px', paddingLeft: '10px' }}><Form.Label>Color</Form.Label></Col>
                                    <Col sm={3} style={{ paddingRight: '10px', paddingLeft: '10px' }}><FormControl type="text" style={{ border: '2px solid #666', borderRadius: '4px', padding: '8px 12px', width: '100%', backgroundColor: '#f8f9fa', boxSizing: 'border-box', color: '#212529' }} onChange={ev => { this.setState({ color: ev.target.value }) }} value={color} /></Col>
                                </FormGroup>
                                <FormGroup className="row" as={Row} controlId="formInlineCustomer" style={{ marginBottom: '20px' }}>
                                    <Col sm={3} style={{ paddingRight: '10px', paddingLeft: '10px' }}><Form.Label>Part No Description</Form.Label></Col>
                                    <Col sm={9} style={{ paddingRight: '10px', paddingLeft: '10px' }}><FormControl type="text" style={{ border: '2px solid #666', borderRadius: '4px', padding: '8px 12px', width: '100%', backgroundColor: '#f8f9fa', boxSizing: 'border-box', color: '#212529' }} onChange={ev => { this.setState({ materialDesc: ev.target.value }) }} value={materialDesc} /></Col>
                                </FormGroup>
                                <FormGroup className="row" as={Row} controlId="formInlineCustomer" style={{ marginBottom: '20px' }}>
                                    <Col sm={3} style={{ paddingRight: '10px', paddingLeft: '10px' }}><Form.Label>Code</Form.Label></Col>
                                    <Col sm={3} style={{ paddingRight: '10px', paddingLeft: '10px' }}><FormControl type="text" style={{ border: '2px solid #666', borderRadius: '4px', padding: '8px 12px', width: '100%', backgroundColor: '#f8f9fa', boxSizing: 'border-box', color: '#212529' }} onChange={ev => { this.setState({ code: ev.target.value }) }} value={code} /></Col>
                                    <Col sm={3} style={{ paddingRight: '10px', paddingLeft: '10px' }}><Form.Label>Usage</Form.Label></Col>
                                    <Col sm={3} style={{ paddingRight: '10px', paddingLeft: '10px' }}><FormControl type="number" step="any" style={{ border: '2px solid #666', borderRadius: '4px', padding: '8px 12px', width: '100%', backgroundColor: '#f8f9fa', boxSizing: 'border-box', color: '#212529' }} onFocus={ev => ev.target.select()} onChange={ev => { this.setState({ usage: ev.target.value === '' ? 0 : parseFloat(ev.target.value) || 0 }) }} value={usage} /></Col>
                                </FormGroup>
                                <FormGroup className="row" as={Row} controlId="formInlinePlanOutput" style={{ marginBottom: '20px' }}>
                                    <Col sm="3" style={{ paddingRight: '10px', paddingLeft: '10px' }}><Form.Label>UoM</Form.Label></Col>
                                    <Col sm="3" style={{ paddingRight: '10px', paddingLeft: '10px' }}> <FormControl as="select" style={{ border: '2px solid #666', borderRadius: '4px', padding: '8px 12px', width: '100%', backgroundColor: '#f8f9fa', WebkitAppearance: 'none', MozAppearance: 'none', appearance: 'none', boxSizing: 'border-box', color: '#212529' }} placeholder="select"
                                        value={this.state.uom} onChange={(e) => {
                                            if (e.target.value != 'select') {
                                                this.setState({ uom: e.target.value });
                                            } else {
                                                delete this.state.uom;
                                            }
                                        }}>
                                        <option value="select">select</option>
                                        {
                                            this.state.uoms.map((uom) => {
                                                return <option key={uom.id} value={uom.id} >{uom.description}</option>
                                            })
                                        }
                                    </FormControl></Col>
                                    <Col sm={3} style={{ paddingRight: '10px', paddingLeft: '10px' }}><Form.Label>Per</Form.Label></Col>
                                    <Col sm={3} style={{ paddingRight: '10px', paddingLeft: '10px' }}><FormControl type="number" step="any" style={{ border: '2px solid #666', borderRadius: '4px', padding: '8px 12px', width: '100%', backgroundColor: '#f8f9fa', boxSizing: 'border-box', color: '#212529' }} onFocus={ev => ev.target.select()} onChange={ev => { this.setState({ per: ev.target.value === '' ? 0 : parseFloat(ev.target.value) || 0 }) }} value={per} /></Col>
                                </FormGroup>
                                <FormGroup className="row" as={Row} controlId="formInlinePlanOutput" style={{ marginBottom: '20px' }}>
                                    <Col sm={3} style={{ paddingRight: '10px', paddingLeft: '10px' }}><Form.Label>Where Use</Form.Label></Col>
                                    <Col sm={3} style={{ paddingRight: '10px', paddingLeft: '10px' }}><FormControl type="text" style={{ border: '2px solid #666', borderRadius: '4px', padding: '8px 12px', width: '100%', backgroundColor: '#f8f9fa', boxSizing: 'border-box', color: '#212529' }} onChange={ev => { this.setState({ where_use: ev.target.value }) }} value={where_use} /></Col>
                                    <Col sm={3} style={{ paddingRight: '10px', paddingLeft: '10px' }}><Form.Label>Source</Form.Label></Col>
                                    <Col sm={3} style={{ paddingRight: '10px', paddingLeft: '10px' }}> <FormControl as="select" style={{ border: '2px solid #666', borderRadius: '4px', padding: '8px 12px', width: '100%', backgroundColor: '#f8f9fa', WebkitAppearance: 'none', MozAppearance: 'none', appearance: 'none', boxSizing: 'border-box', color: '#212529' }} placeholder="select"
                                        value={this.state.source} onChange={(e) => {
                                            if (e.target.value != 'select') {
                                                this.setState({ source: e.target.value });
                                            } else {
                                                delete this.state.source;
                                            }
                                        }}>
                                        <option value="select">select</option>
                                        {
                                            this.state.sources.map((source) => {
                                                return <option key={source.id} value={source.id}>{source.description}</option>
                                            })
                                        }
                                    </FormControl></Col>
                                </FormGroup>
                                <FormGroup className="row" as={Row} controlId="formInlinePlanOutput" style={{ marginBottom: '20px' }}>
                                    <Col sm={3} style={{ paddingRight: '10px', paddingLeft: '10px' }}><Form.Label>Category</Form.Label></Col>
                                    <Col sm={3} style={{ paddingRight: '10px', paddingLeft: '10px' }}> <FormControl as="select" style={{ border: '2px solid #666', borderRadius: '4px', padding: '8px 12px', width: '100%', backgroundColor: '#f8f9fa', WebkitAppearance: 'none', MozAppearance: 'none', appearance: 'none', boxSizing: 'border-box', color: '#212529' }} placeholder="select"
                                        value={this.state.category} onChange={(e) => {
                                            if (e.target.value != 'select') {
                                                this.setState({ category: e.target.value });
                                            } else {
                                                delete this.state.category;
                                            }
                                        }}>
                                        <option value="select">select</option>
                                        {
                                            this.state.categories.map((category) => {
                                                return <option key={category.id} value={category.id}>{category.description}</option>
                                            })
                                        }
                                    </FormControl></Col>
                                    <Col sm={3} style={{ paddingRight: '10px', paddingLeft: '10px' }}><Form.Label>Supplier</Form.Label></Col>
                                    <Col sm={3} style={{ paddingRight: '10px', paddingLeft: '10px' }}><FormControl type="text" style={{ border: '2px solid #666', borderRadius: '4px', padding: '8px 12px', width: '100%', backgroundColor: '#f8f9fa', boxSizing: 'border-box', color: '#212529' }} onChange={ev => { this.setState({ supplier: ev.target.value }) }} value={supplier} /></Col>
                                </FormGroup>
                            </Form>
                        </div>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" onClick={handleClose}>
                            Cancel
                        </Button>
                        {newMode && (<Button variant="primary" onClick={handleCreate} disabled={!isPartNoCreateEnabled(this.state.partNoValidationStatus)}>
                            Create
                        </Button>)}

                        {!newMode && (<Button variant="primary" onClick={handleSave} disabled={!isPartNoCreateEnabled(this.state.partNoValidationStatus)}>
                            Save Changes
                        </Button>)}
                    </Modal.Footer>
                </Modal>

                {/* ---- Copy Sub-materials Selection Modal ---- */}
                <Modal
                    size="lg"
                    show={this.state.copyModalShow}
                    onHide={() => this.setState({ copyModalShow: false })}
                    aria-labelledby="copy-modal-title"
                >
                    <Modal.Header closeButton>
                        <Modal.Title id="copy-modal-title">
                            Copy Sub-materials from &quot;{this.state.copySourceRow ? this.state.copySourceRow.material : ''}&quot;
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        {(this.state.copySourceChildren || []).length === 0 ? (
                            <p style={{ color: '#666' }}>No direct sub-materials found for this row.</p>
                        ) : (
                            <React.Fragment>
                                {/* Toolbar: Select All checkbox + counter */}
                                <div style={{ display: 'flex', gap: '8px', marginBottom: '12px', alignItems: 'center', padding: '0 8px' }}>
                                    <input
                                        type="checkbox"
                                        id="copy-select-all"
                                        checked={(this.state.copySourceChildren || []).length > 0 && this.state.selectedCopyIds.size === (this.state.copySourceChildren || []).length}
                                        onChange={(e) => {
                                            if (e.target.checked) {
                                                const allIds = new Set((this.state.copySourceChildren || []).map(c => c.id));
                                                this.setState({ selectedCopyIds: allIds });
                                            } else {
                                                this.setState({ selectedCopyIds: new Set() });
                                            }
                                        }}
                                        style={{ width: '16px', height: '16px', cursor: 'pointer', margin: 0 }}
                                    />
                                    <label htmlFor="copy-select-all" style={{ margin: 0, cursor: 'pointer', fontWeight: '500', fontSize: '14px' }}>
                                        Select All
                                    </label>
                                    <span style={{ marginLeft: 'auto', fontSize: '13px', color: '#666' }}>
                                        {this.state.selectedCopyIds.size} / {(this.state.copySourceChildren || []).length} selected
                                    </span>
                                </div>

                                {/* Checklist */}
                                <div style={{ maxHeight: '400px', overflowY: 'auto', border: '1px solid #dee2e6', borderRadius: '4px' }}>
                                    {(this.state.copySourceChildren || []).map((child, idx) => (
                                        <div
                                            key={child.id}
                                            style={{
                                                display: 'flex',
                                                alignItems: 'center',
                                                padding: '10px 14px',
                                                borderBottom: idx < (this.state.copySourceChildren.length - 1) ? '1px solid #f0f0f0' : 'none',
                                                backgroundColor: this.state.selectedCopyIds.has(child.id) ? '#f0f7ff' : '#fff',
                                                transition: 'background-color 0.15s',
                                            }}
                                        >
                                            <input
                                                type="checkbox"
                                                id={`copy-child-${child.id}`}
                                                checked={this.state.selectedCopyIds.has(child.id)}
                                                onChange={(e) => {
                                                    const newSet = new Set(this.state.selectedCopyIds);
                                                    if (e.target.checked) newSet.add(child.id);
                                                    else newSet.delete(child.id);
                                                    this.setState({ selectedCopyIds: newSet });
                                                }}
                                                style={{ marginRight: '12px', width: '16px', height: '16px', cursor: 'pointer', flexShrink: 0 }}
                                            />
                                            <label htmlFor={`copy-child-${child.id}`} style={{ margin: 0, cursor: 'pointer', flex: 1 }}>
                                                <span style={{ fontWeight: '600' }}>{child.material || '(unnamed)'}</span>
                                                {child.children && child.children.length > 0 && (
                                                    <span style={{ marginLeft: '8px', fontSize: '0.8em', color: '#0d6efd', fontStyle: 'italic' }}>
                                                        (+{child.children.length} nested sub-item{child.children.length > 1 ? 's' : ''} will also be copied)
                                                    </span>
                                                )}
                                            </label>
                                        </div>
                                    ))}
                                </div>
                            </React.Fragment>
                        )}
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" onClick={() => this.setState({ copyModalShow: false })}>
                            Cancel
                        </Button>
                        <Button
                            variant="primary"
                            disabled={this.state.selectedCopyIds.size === 0}
                            onClick={this.handleCopyConfirm}
                        >
                            Copy Selected ({this.state.selectedCopyIds.size})
                        </Button>
                    </Modal.Footer>
                </Modal>
            </div>

        );
    }
}

export { BomList };
